import { create } from "zustand"

export interface NotificationItem {
  id: string
  title: string
  body: string
  timestamp: string
  read: boolean
  type?: string
  metadata?: any
}

interface NotificationState {
  notifications: NotificationItem[]
  unreadCount: number
  hasFetched: boolean
  setUnreadCount: (count: number) => void
  setHasFetched: (fetched: boolean) => void
  incrementUnreadCount: () => void
  decrementUnreadCount: () => void
  addNotification: (notification: Omit<NotificationItem, "id" | "timestamp" | "read">) => void
  markAllAsRead: () => void
  clearNotifications: () => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  hasFetched: false,

  setUnreadCount: (count) => set({ unreadCount: count }),
  setHasFetched: (fetched) => set({ hasFetched: fetched }),
  incrementUnreadCount: () => set((state) => ({ unreadCount: state.unreadCount + 1 })),
  decrementUnreadCount: () => set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) })),

  addNotification: (notification) =>
    set((state) => {
      const generatedId = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).substring(2, 9) + Date.now().toString(36)
      const newItem: NotificationItem = {
        ...notification,
        id: generatedId,
        timestamp: new Date().toISOString(),
        read: false,
      }
      return {
        notifications: [newItem, ...state.notifications],
        unreadCount: state.unreadCount + 1,
      }
    }),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  clearNotifications: () =>
    set({
      notifications: [],
      unreadCount: 0,
      hasFetched: false,
    }),
}))
